import classNames from "classnames"
import { string } from "prop-types"

import "./icon.scss"

const Icon = ({ iconUrl, modifierClass, style }) => (
  <i
    className={classNames("icon", {
      [`icon--${modifierClass}`]: modifierClass,
    })}
    style={{ backgroundImage: `url(${iconUrl})`, ...style }}
  />
)

Icon.propTypes = {
  iconUrl: string.isRequired,
}

export default Icon
